<p class="page-title mb-4">{{labelPageTitle}}</p>
<section [class.d-none]="currentMode !== Mode.newMailSet">
  <div class="row justify-content-center">
    <div class="col-sm-4 d-none d-sm-block"></div>

    <div class="col-sm-4 col-xs-12">
      <p class="page-title mb-2"><span class="badge badge-secondary mr-2">Step 1 / 2 </span>メールアドレス入力</p>
      <p>メールアドレス再設定の為の<strong>「検証コード」</strong>をメールで送信します。</p>
      <a routerLink="/mailchange" (click)="currentMode = Mode.newMailVerify;">※検証コードを既にお持ちの方はこちら</a>
      <div class="mb-3 mt-3">
        <label class="col-form-label w-100 origin-form-label">{{labelNewMail}}</label>
        <input id="newMail" name="newMail" type="text" class="w-100 text-left" [formControl]="newMail"/>
      </div>
      <div class="mb-3">
        <label class="col-form-label w-100 origin-form-label">{{labelNewMailConfirm}}</label>
        <input id="newMailConfirm" name="newMailConfirm" type="text" class="w-100 text-left" [formControl]="newMailConfirm"/>
      </div>
      <div *ngIf="authServ.isLoading" class="loading-area-sm">
        <app-loading [loadImgClass]="loadImgClass"></app-loading>
      </div>
      <button type="button" [class.d-none]="authServ.isLoading" class="btn btn-primary btn-block mt-5"
              (click)="updateMail()">検証コード発行</button>
    </div>

    <div class="col-sm-4 d-none d-sm-block"></div>

    <div class="col-sm-4 col-xs-12 mt-5 text-center">
      <small class="text-secondary">ご利用の環境によっては、メールが届くまでお時間を要する場合があります。予めご了承の程、お願い致します。</small>
    </div>
  </div>
</section>

<section [class.d-none]="currentMode !== Mode.newMailVerify">
  <div class="row justify-content-center">
    <div class="col-sm-4 col-xs-12">
      <p class="page-title mb-2"><span class="badge badge-secondary mr-2">Step 2 / 2 </span>検証コード入力</p>
      <p>受信したメールに記載された<strong>「検証コード」</strong>を入力して下さい。</p>
      <div class="mb-3">
        <label class="col-form-label w-100 origin-form-label">{{labelVerifyCode}}</label>
        <input id="verifyCode" name="verifyCode" type="text" class="w-100 text-left" [formControl]="verifyCode"/>
      </div>
      <button type="button" class="btn btn-primary btn-block mt-5" (click)="verifyNewMail()">メールアドレス変更</button>
      <button type="button" class="btn btn-outline-secondary btn-block mt-4"
              (click)="currentMode = Mode.newMailSet;">キャンセル
      </button>
    </div>
  </div>
</section>
